/**
 * Joins class names, dropping falsy values.
 *
 * <p>Deliberately not `clsx` + `tailwind-merge`: two dependencies to solve a problem
 * that disciplined component APIs avoid. Variants are chosen with a lookup object rather
 * than by overriding classes, so there is nothing to merge.
 */
export function cn(...values: Array<string | false | null | undefined>): string {
  return values.filter(Boolean).join(' ');
}
